export default __webpack_public_path__ + "static/media/Rubik-Regular.2d2d778d.woff2";